import React, { useEffect, useState } from 'react';
import {
  Box,
} from '@mui/material';
import Navbar from '../components/Navbar';
import '../components/css/Dashboard.css';
import { api } from '../helpers/apiRequest';
import { toast } from 'react-toastify';

const Dashboard = () => {

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Navbar title="Ideal Garments" />
      </Box>

   
    </>
  );
};

export default Dashboard;
